import { Dialog, Loading, Notify } from 'quasar';
import 'quasar/src/css/index.sass';

// Import icon libraries
import '@quasar/extras/material-icons-outlined/material-icons-outlined.css';
import '@quasar/extras/material-icons/material-icons.css';
import '@quasar/extras/material-symbols-outlined/material-symbols-outlined.css';

export function setupQuasar() {
  Notify.setDefaults({
    color: 'green',
    textColor: 'white',
    timeout: 4000,
    actions: [
      {
        icon: 'close',
        color: 'white',
      },
    ],
  });

  return {
    plugins: { Dialog, Notify, Loading },
    config: {
      notify: {},
      loading: {},
      dark: false,
    },
  };
}
